<template>
  <div> <!-- root element of the template -->
    <cm-change-password-popup v-if="changePasswordPopup" @close="changePasswordPopup = false" :data="changePasswordPopupData" class="z-10080"></cm-change-password-popup>
    <cm-switch-profile :closeButton="true"></cm-switch-profile>
    <cm-user-reset-password :closeButton="true"></cm-user-reset-password>
    <document-viewer v-if="documentViewer" @close="documentViewer = false" :data="documentViewerData"></document-viewer>
    <cm-json-details v-if="jsonDetails" @close="jsonDetails = false" :jsonDetailsData="jsonDetailsData" ></cm-json-details>
  </div>
</template>

<script>
// contacts
import CMAddContact from '@/popups/contacts/CMAddContact.vue'
import CMAddContactGroup from '@/popups/contacts/CMAddContactGroup.vue'
import CMEditContact from '@/popups/contacts/CMEditContact.vue'

import ProfileSwitcherPopup from '@/popups/switchProfile/switchProfile.vue'

import DocumentViewer from '@/popups/attachments/DocumentViewer.vue'

import CMChangePasswordPopup from './user/CMChangePasswordPopup.vue'

import CMUserResetPassword from '@/popups/user/CMUserResetPassword.vue'
import CMJsonDetails from "@/popups/json/CMJsonDetails.vue";


export default {
  name: 'cm-popups',
  components: {
    'cm-change-password-popup': CMChangePasswordPopup,
    'cm-contact-add-popup': CMAddContact,
    'cm-contact-group-add-popup': CMAddContactGroup,
    'cm-contact-edit-popup': CMEditContact,
    'cm-json-details': CMJsonDetails,
    'cm-user-reset-password': CMUserResetPassword,
    'cm-switch-profile': ProfileSwitcherPopup,
    'document-viewer': DocumentViewer
  },
  data () {
    return {
      changePasswordPopup: false,
      changePasswordPopupData: '',
      choiceBankAccount: false,
      choiceBankAccountData: '',
      devisForm: false,
      devisFormData: '',
      documentViewer: false,
      documentViewerData: '',
      accountId: '',
      jsonDetails: false,
      jsonDetailsData: ''
    }
  },
  created () {
    this.$bus.$on('close-all-popups', () => {
      this.changePasswordPopup = false
      this.choiceBankAccount = false
      this.devisForm = false
      this.documentViewer = false
    })
    this.$bus.$on('popup-change-password-data', e => {
      this.changePasswordPopupData = e
      this.changePasswordPopup = true
    })
    this.$bus.$on('popup-document-viewer', e => {
      this.documentViewerData = e
      this.documentViewer = true
    })
    this.$bus.$on('popup-json-details', e => {
      this.jsonDetailsData = e
      this.jsonDetails = true
    })
  }
}
</script>
